import googleMapsApi from 'google-maps-api';

const getInfowindowContent = item => {
	let infoContent = `<div style="max-width: 173px;"><a href="${item.url}" style="text-decoration: none; color: inherit;">`;
	infoContent += item.title ? `<p style="text-transform: uppercase;">${item.title}</p>` : '';
	infoContent += item.kicker ? `<p><span class="link" style="color: #e40613; text-decoration: underline; text-transform: none;">${item.kicker}</span></p>` : '';
	infoContent += item.content ? `<p>${item.content}</p>` : '';
	infoContent += item.image ? `<img class="img" alt="" src="${item.image}" title="">` : '';
	infoContent += '</a></div>';

	return infoContent;
};

function mapsFallback(node)
{
	let mapsFallback = true;

	if (typeof CCM == 'undefined') {
		mapsFallback = false;
	} else {
		CCM.acceptedEmbeddings.forEach(element => {
			if (element.name === 'Google Maps') {
				mapsFallback = false;
			}
		})
	}

	if (mapsFallback) {
		const mapsFallbackElement = node.querySelector("[data-mapsFallback]");
		if (mapsFallbackElement instanceof HTMLElement) {
			const attribute = mapsFallbackElement.getAttribute('data-mapsFallback');
			if (attribute) {
				mapsFallbackElement.classList.add(attribute);
			}
		}
	}
}

export default el => {
	window.addEventListener('ccm19WidgetClosed', function () {
		mapsFallback(el);
	});
	mapsFallback(el);

	const mapElement = el.querySelector('.map__element');
	const mapData = JSON.parse(el.querySelector('.map__data').innerHTML);
	const mapCenterLatitude = el.getAttribute('data-latitude');
	const mapCenterLongitude = el.getAttribute('data-longitude');
	const mapZoom = el.getAttribute('data-zoom');

	const apiKey = el.getAttribute('data-api-key');

	const defaultMapOptions = {
		zoom: 15,
		zoomControl: true,
		scrollwheel: false,
		disableDoubleClickZoom: true,
		streetViewControl: false
	}

	let map = null;
	let markers = [];
	let mapOptions = Object.assign(defaultMapOptions,{});
	const api = googleMapsApi(apiKey);

	var head = document.getElementsByTagName('head')[0];
	var insertBefore = head.insertBefore;
	head.insertBefore = function (newElement, referenceElement) {
		if (newElement.href && newElement.href.indexOf('//fonts.googleapis.com/css?family=') > -1) {
			return;
		}
		insertBefore.call(head, newElement, referenceElement);
	};

	api().then(() => {
		// init map
		if (mapCenterLatitude && mapCenterLongitude) {
			mapOptions.center = {lat: parseFloat(mapCenterLatitude), lng: parseFloat(mapCenterLongitude)};
		}
		if (mapZoom) {
			mapOptions.zoom = parseInt(mapZoom);
		} else {
			mapOptions.zoom = parseInt(defaultMapOptions.zoom);
		}
		map = new google.maps.Map(mapElement, mapOptions);
	}).then(() => {
		//add markers
		if (mapData.markers) {
			let lastWindow;
			const markerGroups = {};

			mapData.markers.forEach((item) => {
				const lat = parseFloat(item.latitude);
				const lng = parseFloat(item.longitude);
				const geoId = `${lat}_${lng}`;

				markerGroups[geoId] = (markerGroups[geoId] || []).concat(item);
			});

			Object.values(markerGroups).forEach((items) => {
				if (!items || items.length <= 0) {
					return;
				}

				const lat = parseFloat(items[0].latitude);
				const lng = parseFloat(items[0].longitude);

				if (lat && lng && (-90 < lat && lat < 90) && (-180 < lng && lng < 180)) {
					let infoWindow = null;
					const marker = new google.maps.Marker({
						position: {lat, lng},
						map,
						title: (items[0].kicker || items[0].title).replace(/&amp;/g, '&'),
						icon: items[0].icon || ''
					});

					marker.addListener('click', function() {
						if (!infoWindow) {
							const infoContent = items
								.map(getInfowindowContent)
								.join();

							infoWindow = new google.maps.InfoWindow({
								content: infoContent
							});

							infoWindow.addListener('closeclick', function() {
								lastWindow = null;
							});
						}

						infoWindow.open(map, marker);
						lastWindow && lastWindow.close();
						lastWindow = lastWindow === infoWindow ? null : infoWindow;
					});

					markers.push({marker, infoWindow, lat, lng});
				}
			});

			map.addListener('click', function() {
				if (lastWindow) {
					lastWindow.close();
					lastWindow = null;
				}
			});
		}
	}).then(() => {
		// zoom to markers
		const zoomChangeBoundsListener = google.maps.event.addListener(map, 'bounds_changed', function(event) {
			if (this.getZoom() > 17) {
				this.setZoom(17);
			}
			google.maps.event.removeListener(zoomChangeBoundsListener);
		});

		if (markers.length > 0) {
			var bounds = new google.maps.LatLngBounds();
			for (var i = 0; i < markers.length; i++) {
				bounds.extend(markers[i]);
			}

			map.fitBounds(bounds);
		}
	}).done();
}
